<div class="ion-page offline-page" mode="ios">
	<ion-header translucent>
		<ion-toolbar color="light">
			<ion-title>Error</ion-title>
		</ion-toolbar>
	</ion-header>
	<ion-content class="offline-wrapper" fullscreen mode="ios">
		<div class="center-wrapper">
			@if (offline) {
			<div class="offline-box">
				<ion-icon name="cloud-offline-outline" size="large" aria-hidden="true"></ion-icon>
				<h2>You are offline</h2>
				<p>You need to be online to use this app. We will retry when you press the button.</p>
				<ion-button mode="ios" expand="block" fill="outline" size="large" (click)="retry()">Retry</ion-button>
			</div>
			}
			@else {
			<div class="offline-box">
				<ion-icon name="thunderstorm-outline" size="large" aria-hidden="true"></ion-icon>
				<h2>A problem occurred</h2>
				<p>Sorry but the server can't be reached. We will retry when you press the button.</p>
				<ion-button mode="ios" expand="block" fill="outline" size="large" (click)="retry()">Retry</ion-button>
			</div>
			}
		</div>
	</ion-content>
</div>